export const Svg_087 = () => (
  <svg  style={{ width: '70px' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
    <defs>
      <linearGradient
        id="a"
        x1={18.8}
        x2={14.3}
        y1={14}
        y2={20.3}
        data-name="Gradiente sem nome"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={27.4}
        x2={23}
        y1={9.6}
        y2={16}
        data-name="Gradiente sem nome 2"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={46.5}
        x2={42.1}
        y1={9.6}
        y2={16}
        data-name="Gradiente sem nome 3"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={37}
        x2={32.5}
        y1={14}
        y2={20.3}
        data-name="Gradiente sem nome 4"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={55.2}
        x2={50.7}
        y1={14}
        y2={20.3}
        data-name="Gradiente sem nome 5"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={50.3}
        x2={16.8}
        y1={12.4}
        y2={60.2}
        data-name="Gradiente sem nome 6"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
    </defs>
    <path
      d="M22.3 54.7c.2-.2.3-.3.3-.6 0-.5-.4-.9-.9-.9s-.4 0-.6.3c0 0-.8.6-1.1.6-.4 0-.8-.3-1.1-.6l-.6-.6-.6.6c-.4.3-.7.5-1.1.6-.4 0-.8-.3-1.1-.6l-.6-.6-.6.6c-.4.3-.7.5-1.1.6-.3 0-1.1-.6-1.1-.6-.3-.3-.9-.3-1.2 0s-.3.9 0 1.2c.6.6 1.5 1 2.3 1.1.6 0 1.2-.3 1.7-.6.5.3 1.1.6 1.7.6s1.2-.3 1.7-.6c.5.3 1.1.6 1.7.6.9 0 1.7-.5 2.3-1.1Z"
      style={{
        fill: "url(#a)",
      }}
    />
    <path
      d="M30.4 57.5c-.3 0-.4 0-.6.3 0 0-.8.6-1.1.6-.4 0-.8-.3-1.1-.6l-.6-.6-.6.6c-.4.3-.7.5-1.1.6-.4 0-.8-.3-1.1-.6l-.6-.6-.6.6c-.4.3-.7.5-1.1.6-.4 0-1.1-.6-1.1-.6-.4-.3-.9-.3-1.2 0s-.4.9 0 1.2c.6.6 1.5 1 2.3 1.1.6 0 1.2-.3 1.7-.6.5.3 1.1.6 1.7.6s1.2-.3 1.7-.6c.5.3 1.1.6 1.7.6.9 0 1.7-.5 2.3-1.1.2-.2.3-.3.3-.6 0-.5-.4-.9-.9-.9Z"
      style={{
        fill: "url(#b)",
      }}
    />
    <path
      d="M49.5 57.5c-.3 0-.4 0-.6.3 0 0-.8.6-1.1.6-.4 0-.8-.3-1.1-.6l-.6-.6-.6.6c-.3.3-.7.5-1.1.6-.4 0-.8-.3-1.1-.6l-.6-.6-.6.6c-.3.3-.7.5-1.1.6-.3 0-1.1-.6-1.1-.6-.3-.3-.9-.3-1.2 0s-.3.9 0 1.2c.6.6 1.5 1 2.3 1.1.6 0 1.2-.3 1.7-.6 1 .9 2.4.9 3.5 0 .5.3 1.1.6 1.7.6.9 0 1.7-.5 2.3-1.1s.3-.3.3-.6c0-.5-.3-.9-.9-.9Z"
      style={{
        fill: "url(#c)",
      }}
    />
    <path
      d="M40.5 54.7c.2-.2.3-.3.3-.6 0-.5-.3-.9-.9-.9s-.4 0-.6.3c0 0-.8.6-1.1.6-.4 0-.8-.3-1.1-.6l-.6-.6-.6.6c-.4.3-.7.5-1.1.6-.4 0-.8-.3-1.1-.6l-.6-.6-.6.6c-.4.3-.7.5-1.1.6-.4 0-1.1-.6-1.1-.6-.4-.3-.9-.3-1.2 0s-.4.9 0 1.2c.6.6 1.5 1 2.3 1.1.6 0 1.2-.3 1.7-.6.5.3 1.1.6 1.7.6s1.2-.3 1.7-.6c.5.3 1.1.6 1.7.6.9 0 1.7-.5 2.3-1.1Z"
      style={{
        fill: "url(#d)",
      }}
    />
    <path
      d="M58.2 53.2c-.3 0-.4 0-.6.3 0 0-.8.6-1.1.6-.4 0-.8-.3-1.1-.6l-.6-.6-.6.6c-.3.3-.7.5-1.1.6-.4 0-.8-.3-1.1-.6l-.6-.6-.6.6c-.3.3-.7.5-1.1.6-.3 0-1.1-.6-1.1-.6-.3-.3-.9-.3-1.2 0s-.3.9 0 1.2c.6.6 1.5 1 2.3 1.1.6 0 1.2-.3 1.7-.6 1 .9 2.4.9 3.5 0 .5.3 1.1.6 1.7.6.9 0 1.7-.5 2.3-1.1s.3-.3.3-.6c0-.5-.3-.9-.9-.9Z"
      style={{
        fill: "url(#e)",
      }}
    />
    <path
      d="M51.2 33c.7.4 1.5.8 2.2 1 .4.2.8.2 1.2.2 1.2 0 2.3-.4 3.3-1 1.4-.9 2.2-2.2 2.6-3.8s0-3.2-.9-4.6c-.6-.9-1.4-1.6-2.3-2.1 1-1.5 1-3.5-.2-5-.6-.9-1.6-1.4-2.6-1.6v-.9c0-2.6-1.3-5.2-4.3-5.2-4.7 0-5.2 2.9-5.2 5.2s.2.9.3 1.2c-1.2.7-2 2.1-2 4s.2 1.5.5 2.1c-2.5 1-4.2 3.5-4 6.3.3 3.3 3.3 5.8 6.6 5.5 1 0 2-.5 2.9-1v6.2h-4.4c-3.6 0-7.2 1-10.3 2.8-3-1.7-6.7-2.8-10.4-2.8h-6.1v-7.6c1.7 1 4 1 5.7-.3 2.3-1.7 2.8-4.9 1.1-7.3-.4-.4-.7-.8-1.1-1.1.4-.7.5-1.5.4-2.3 0-1.1-.7-2.2-1.6-2.9-.4-.3-.8-.5-1.2-.7.2-.7.3-1.5 0-2.2-.3-1.1-.9-2.1-2-2.7-2-1.2-4.6-.6-5.9 1.5-.6 1-.8 2.2-.4 3.4-1.7.7-2.9 2.4-2.8 4.4 0 .5.2 1 .4 1.5-2 1.4-2.8 4.1-1.7 6.4.9 1.9 2.7 3 4.7 3s1.5-.2 2.2-.5c.2 0 .3-.2.4-.3v7.7H8.5v1.7h15.6c7.4 0 13.2 4.2 15.4 8.4-.5.2-1 .3-1.6.3-1.1 0-2.2-.3-3.1-.8l-.4-.2-.4.2c-1 .4-2.1.7-3 .8-1.1 0-2.2-.3-3.1-.8l-.4-.2-.4.2c-1 .4-2.1.7-3 .8-1.1 0-2.2-.3-3.1-.8l-.4-.2-.4.2c-.9.4-2.1.7-3 .8-1.1 0-2.2-.3-3.1-.8l-.4-.2-.4.2c-1.3.5-2.6.8-4 .8h-.9v1.7h1c1.5 0 2.9-.3 4.2-.8 1.1.4 2.2.7 3.6.8 1.2 0 2.3-.3 3.5-.8 1.1.4 2.2.7 3.5.8 1.2 0 2.3-.3 3.5-.8 1.1.4 2.2.7 3.5.8 1.2 0 2.3-.3 3.5-.8 1.1.4 2.3.7 3.5.8 1.2 0 2.3-.3 3.5-.8 1.1.4 2.2.7 3.5.8 1.2 0 2.3-.3 3.5-.8 1.1.4 2.2.7 3.5.8 1.2 0 2.3-.3 3.5-.8 1.1.4 2.2.7 3.5.8h1.7v-1.7h-1.7c-1.1 0-2.2-.3-3.1-.8l-.4-.2-.3.2c-1 .4-2.1.7-3 .8-1.1 0-2.2-.3-3.1-.8l-.4-.2-.3.2c-1 .4-2.1.7-3 .8-1.1 0-2.2-.3-3.1-.8l-.4-.2-.3.2c-1.1-2.2-2.9-4.2-4.9-5.7 2.7-1.4 5.6-2.1 8.7-2.1h15.7v-1.7h-9.5v-6.4Zm-4.7-.6c-2.4.3-4.5-1.5-4.8-3.9 0-1.1.3-2.2 1-3.2.7-.9 1.7-1.5 3-1.6l2.1-.2-1.6-1.3c-.6-.5-1-1.2-1-2s.2-2.4 1.8-2.6l1.4-.2-.7-1.1c0-.2-.2-.4-.3-.4-.2-.4-.4-.7-.4-.9 0-2.2.6-3.5 3.5-3.5s2.6 2.9 2.6 3.5v2.6h.9c.8 0 1.6.4 2.1 1 .9 1.1.6 2.8-.5 3.6l-1.5 1.1 1.8.4c1 .3 2 .9 2.6 1.8s.9 2.1.6 3.3-.9 2.1-1.8 2.8c-1 .6-2.1.9-3.3.6-1-.2-2-.8-2.6-1.6v-1.9l3.8-1.6c.4-.2.7-.7.4-1.1-.2-.4-.7-.7-1.1-.4l-3.1 1.1v-7.5c0-.5-.3-.9-.9-.9s-.9.4-.9.9v7.5l-3.1-1.3c-.4-.2-1 0-1.1.4s0 1 .4 1.1l3.8 1.6v2c-.7 1-1.8 1.6-3 1.7Zm-31.1-2.1c-.9.4-1.8.4-2.7 0s-1.6-1-1.9-1.8-.4-1.8 0-2.7.9-1.6 1.8-1.9l1-.4-.7-.9c-.3-.4-.5-.9-.5-1.4-.2-1.4.9-2.7 2.3-2.8l1.4-.2-.7-1.2c-.5-.9-.5-1.8 0-2.7.3-.7 1.1-1.1 2-1.1s.9 0 1.3.4c.6.4 1 .9 1.2 1.6s0 1.4-.3 2l-.7 1.2 1.4.2c.5 0 .9.3 1.4.5.5.4.9 1 1 1.7 0 .7 0 1.4-.5 1.9l-.7.9 1 .4c.5.3 1 .6 1.3 1 1.1 1.6.8 3.7-.7 4.9-1.5 1-3.5.8-4.7-.5v-1.6l3.7-.8c.4 0 .8-.5.7-1 0-.4-.5-.8-1-.7l-3.6.7v-5c0-.5-.4-.9-.9-.9s-.9.4-.9.9v5l-3.3-.7c-.4 0-.9.2-1 .7 0 .4.2 1 .7 1l3.6.7v1.6c-.4.4-.7.7-1.1.9Z"
      style={{
        fill: "url(#f)",
      }}
    />
  </svg>
)